import type { Sport } from '#src/__generated__/globalTypes.ts';

import {
  findLatestCardSetConfig,
  getCollectionBackground,
  getCollectionBackgroundUrl,
} from './index.ts';

// Hook wrappers around the plain card-set lookup functions.
//
// These exist so call sites depend on a hook, not a module-level function.
// Today (Tranche 1) they delegate straight to the pure functions in ./index,
// so behavior is unchanged. When card-set branding moves behind the GraphQL
// API, only these hook bodies switch to reading CardSetBrandingContext — the
// call sites don't change again. The pure functions stay exported from ./index
// for unit tests and for these wrappers.

export const useFindLatestCardSetConfig = () => (sport: Sport) =>
  findLatestCardSetConfig(sport);

export const useGetCollectionBackground =
  () => (setSlug: Nullable<string>, teamSlug: Nullable<string>) =>
    getCollectionBackground(setSlug, teamSlug);

export const useGetCollectionBackgroundUrl =
  () => (setSlug: Nullable<string>, teamSlug: Nullable<string>) =>
    getCollectionBackgroundUrl(setSlug, teamSlug);
